import styled from '@emotion/styled';
import { CommonWrapper } from 'screens/AgentOfficePages/styled';


export const DescrWrapper = styled.div`
  position: relative;
  display: flex;
  padding: ${({ theme }) => theme.spacing(4)};
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  position: relative;
  width: 100%;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: 0;
    border: 0 none;
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    min-height: 358px;
  `}
`;

export const AgentCardWrapper = styled.div`
  max-width: 168px;
`;

export const SocialWrapper = styled.div`
  position: absolute;
  top: 32px;
  left: 32px;
`;

export const AboutWrapperSection = styled(CommonWrapper)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: flex-start;
  > :last-child {
    flex-shrink: 0;
    width: 342px;
    ${({ theme }) => theme.media.showAt({ to: 2 })`
      width: 100%;
    `}
  }
`;

export const InfoWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin-right: ${theme.spacing(2.5)};
  `}
`;
